import axios from "axios";
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { useParams } from "react-router-dom";
import "../Content/FanStar.css";

const FanAnalytics = () => {
  const [analytics, setAnalytics] = useState();
  const [anotherAnalytics, setAnotherAnalytics] = useState({});
  const [fisrtstar, setFirstStar] = useState();
  const [secondstar, setSecondStar] = useState();
  const [dateAll, setDateAll] = useState({});
  const [dateAll2, setDateAll2] = useState();

  let { slug } = useParams();


  useEffect(() => {
    axios.get(`/api/user/fan/group/analytics/${slug}`).then((res) => {
      if (res.status === 200) {
        setAnalytics(res.data.myStarAnalytics);
        setAnotherAnalytics(res.data.anotherStarAnalytics);
        setFirstStar(
          res.data.fanDetails?.my_superstar?.first_name +
          " " +
          res.data.fanDetails?.my_superstar?.last_name
        );
        setSecondStar(
          res.data.fanDetails?.another_superstar?.first_name +
          " " +
          res.data.fanDetails?.another_superstar?.last_name
        );
        setDateAll(res.data.myStarWeek);
        // setDateAll2(res.data.anotherStarPosts);
      }
    });
  }, [slug]);

  // const values = dateAll && Object.values(dateAll);
  // const values2 = dateAll2 && Object.values(dateAll2);

  // const resultLength =
  //   values &&
  //   values.reduce((acc, cur) => {
  //     acc.push(cur.length);
  //     return acc;
  //   }, []);

  // const resultLength2 =
  //   values2 &&
  //   values2.reduce((acc, cur) => {
  //     acc.push(cur.length);
  //     return acc;
  //   }, []);

  const data = {
    // labels: ["1", "2", "3", "4", "5"],
    labels: dateAll.toString(),
    bezierCurve: false,
    datasets: [
      {
        label: fisrtstar,
        data: analytics,
        fill: true,
        backgroundColor: "#39bf21",
        borderColor: "#FEF40B",
      },
      {
        label: secondstar,
        data: anotherAnalytics,
        fill: true,
        backgroundColor: "#2215e7",
        borderColor: "#742774",
      },
    ],
  };

  const legend = {
    display: true,
    position: "bottom",
    labels: {
      fontColor: "#323130",
      fontSize: 14,
    },
  };

  const options = {
    title: {
      display: true,
      text: "Chart Title",
    },
    scales: {
      yAxes: [
        {
          ticks: {
            suggestedMin: 0,
            suggestedMax: 100,
          },
        },
      ],
    },
  };

  return (
    <>
      <div className="MediaBG mt-3">
        <div className="row ms-1 me-1">
          <Bar data={data} legend={legend} options={options} />
        </div>
      </div>
    </>
  );
};

export default FanAnalytics;
